import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import SvgIcon from '@mui/material/SvgIcon'
import Typography from '@mui/material/Typography'
import getCardColor from './getCardColor'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid'
import Tooltip from '@mui/material/Tooltip'
import { Skeleton } from '@mui/material'

const NumberCardTwo = ({
  number,
  label,
  color,
  onClick,
  loading,
  fontColor,
  tooltipTitle,
  lg,
  ...props
}) => {
  const [main, setMain] = useState(null)
  const [light, setLight] = useState(null)
  // const {main, light} = getCardColor(color)
  useEffect(() => {
    const { main, light } = getCardColor(color)
    setMain(main)
    setLight(light)
  }, [color])
  return (
    <Grid item xs={6} sm={6} md={4} lg={lg ?? 3}>
      {loading ? (
        <Skeleton width="100%" height="100%" />
      ) : (
        <Tooltip title={tooltipTitle}>
          <Box
            onClick={onClick}
            sx={{
              borderRadius: 1,
              backgroundColor: light,
              color: fontColor ?? main,
              borderColor: main,
              borderWidth: 1,
              borderStyle: 'solid',
              padding: 0.5,
              paddingX: 2,
              flex: 1,
              gap: 1,
              display: 'flex',
              alignItems: 'center',
              height: '100%',
              justifyContent: 'space-between',
              cursor: onClick && 'pointer',
              ...props,
            }}
          >
            <Box
              display="flex"
              fontWeight="bold"
              fontFamily="arial"
              sx={{
                // 25% of a phone-width card is too narrow for values like
                // "50%" — let the number size itself and keep the label clear
                width: { xs: 'auto', md: '25%' },
                minWidth: { xs: 'fit-content', md: '25%' },
                flexShrink: 0,
                mr: { xs: 1, md: 0 },
                fontSize: { xs: '1.5rem', md: '2rem' },
              }}
            >
              {number}
            </Box>
            <Box
              fontSize="1rem"
              display="flex"
              flexWrap="wrap-reverse"
              alignItems="flex-end"
              justifyContent="center"
            >
              {label}
            </Box>
          </Box>
        </Tooltip>
      )}
    </Grid>
  )
}

export default NumberCardTwo
